import React from "react";
import { Typography } from "@mui/material";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";

const AuditInfo = ({ createdAt, createdBy, updatedAt, updatedBy }) => {
    const { t } = useTranslation(['components']);

    if(!createdAt && !updatedAt) {
        return null;
    }

    const formatDate = (dateString) => {
        try {
            return format(new Date(dateString), "dd/MM/yyyy HH:mm");
        } catch {
            return dateString;
        }
    };

    return (
        <Typography
            variant="caption"
            color="text.secondary"
            textAlign="center"
            sx={{ display: "block", mt: 2 }}
        >
            {
                createdAt && `${t("auditInfo.createdAt")} ${formatDate(createdAt)}`
            }
            {
                createdBy && ` ${t("auditInfo.createdBy")} ${createdBy}`
            }
            {
                updatedAt && <br />
            }
            {
                updatedAt && `${t("auditInfo.updatedAt")} ${formatDate(updatedAt)}`
            }
            {
                updatedBy && ` ${t("auditInfo.updatedBy")} ${updatedBy}`
            }
        </Typography>
    );
};

export default AuditInfo;
